import { getTransferDetail } from 'client/stock-transfers/stock-transfers.client'

export const transferDetailLoader = async ({ params }) => {
  return await getTransferDetail(`${params.transferId}`)
}
